import React from "react";

import {
  AppBar,
  Box,
  Chip,
  Hidden,
  IconButton,
  SvgIcon,
  Toolbar,
  makeStyles,
} from "@material-ui/core";

import { Menu as MenuIcon } from "react-feather";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import clsx from "clsx";

import {
  DESKTOP_TOP_BAR_HEIGHT,
  MOBILE_TOP_BAR_HEIGHT,
} from "@hubcapp/constants";
import { Logo } from "@hubcapp/components";

import { TopBarProps } from "./types";
import Account from "../Account";

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
  },
  toolbar: {
    paddingLeft: theme.spacing(1),
    minHeight: MOBILE_TOP_BAR_HEIGHT,
    [theme.breakpoints.up("md")]: {
      minHeight: DESKTOP_TOP_BAR_HEIGHT,
      paddingLeft: theme.spacing(3),
    },
    justifyContent: "space-between",
  },
  logoText: {
    fill: theme.palette.common.white,
  },
  logoPattern: {
    fill: theme.palette.common.white,
  },
  helpButtonWrapper: {
    width: "40px",
    height: "40px",
    background: "rgba(255, 255, 255, 0.08)",
    borderRadius: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  demoButton: {
    backgroundColor: "white",
    color: "#263238",
    marginLeft: "64px", // offset to re-centre button
  },
}));

const TopBar = ({
  className,
  onMobileNavOpen = () => {},
  displayExperimentBanner = () => {},
  ...rest
}: TopBarProps) => {
  const classes = useStyles();

  const handleHelpClick = () => {
    window.open("https://help.drivingservices.org/", "hubcappHelp");
  };

  return (
    <AppBar
      className={clsx(classes.root, className)}
      data-test="top-bar"
      position="fixed"
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
            data-test="open-menu-button"
          >
            <SvgIcon fontSize="default">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>

        <Hidden mdDown>
          <RouterLink to="/">
            <Logo
              textClass={classes.logoText}
              patternClass={classes.logoPattern}
            />
          </RouterLink>
        </Hidden>

        {window?._env_?.DISPLAY_EXPERIMENT_BANNER === "true" && (
          <Chip
            onClick={displayExperimentBanner}
            label="DEMO MODE"
            className={classes.demoButton}
          />
        )}

        <Box display="flex">
          <Hidden lgUp>
            <IconButton color="inherit" onClick={handleHelpClick}>
              <div className={classes.helpButtonWrapper}>
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
                    stroke="#fff"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.381 9.3a2.7 2.7 0 0 1 5.247.9c0 1.8-2.7 2.7-2.7 2.7M12 16.5h.009"
                    stroke="#fff"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </IconButton>
          </Hidden>

          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
